import { render, staticRenderFns } from "./AllBoards.vue?vue&type=template&id=ef2a387c&scoped=true"
import script from "./AllBoards.vue?vue&type=script&lang=js"
export * from "./AllBoards.vue?vue&type=script&lang=js"
import style0 from "./AllBoards.vue?vue&type=style&index=0&id=ef2a387c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2a387c",
  null
  
)

export default component.exports